import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

export const SettingsIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      {/* Engrenage stylisé : pétales arrondies */}
      <path
        d="M12 2.5c.5 0 .9.3 1 .8l.3 1.6c.6.2 1.2.5 1.7.8l1.4-.9c.4-.3 1-.2 1.3.2l1.3 1.3c.3.3.4.9.2 1.3l-.9 1.4c.3.5.6 1.1.8 1.7l1.6.3c.5.1.8.5.8 1v1.8c0 .5-.3.9-.8 1l-1.6.3c-.2.6-.5 1.2-.8 1.7l.9 1.4c.3.4.2 1-.2 1.3l-1.3 1.3c-.3.3-.9.4-1.3.2l-1.4-.9c-.5.3-1.1.6-1.7.8l-.3 1.6c-.1.5-.5.8-1 .8h-1.8c-.5 0-.9-.3-1-.8l-.3-1.6c-.6-.2-1.2-.5-1.7-.8l-1.4.9c-.4.3-1 .2-1.3-.2l-1.3-1.3c-.3-.3-.4-.9-.2-1.3l.9-1.4c-.3-.5-.6-1.1-.8-1.7l-1.6-.3c-.5-.1-.8-.5-.8-1v-1.8c0-.5.3-.9.8-1l1.6-.3c.2-.6.5-1.2.8-1.7l-.9-1.4c-.3-.4-.2-1 .2-1.3l1.3-1.3c.3-.3.9-.4 1.3-.2l1.4.9c.5-.3 1.1-.6 1.7-.8l.3-1.6c.1-.5.5-.8 1-.8H12z"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Centre menthe */}
      <circle cx="12" cy="12" r="2.5" fill="var(--equiply-icon-bg)" />
    </svg>
  ),
);
SettingsIcon.displayName = "SettingsIcon";
